var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgPhone = function SvgPhone(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 94,
    viewBox: "0 0 52 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 0.875H8C4.06497 0.875 0.875 4.06497 0.875 8V86C0.875 89.935 4.06497 93.125 8 93.125H44C47.935 93.125 51.125 89.935 51.125 86V8C51.125 4.06497 47.935 0.875 44 0.875Z",
    stroke: "white",
    strokeWidth: 1.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 3.5H8C5.51472 3.5 3.5 5.51472 3.5 8V86C3.5 88.4853 5.51472 90.5 8 90.5H44C46.4853 90.5 48.5 88.4853 48.5 86V8C48.5 5.51472 46.4853 3.5 44 3.5Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4363 32H9.39648V45.4957H22.4394L22.4363 32ZM19.1748 42.121H12.6549V35.3747H19.1748V42.121ZM28.9562 37H41.9991V40.121H28.9593L28.9562 37ZM28.9593 57H42.0023L41.9991 60.1675L28.9593 60.1707V57Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 7H30",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7H19",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 58.5L15 62.5L22 52",
    stroke: "white",
    strokeWidth: 3.5
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTIiIGhlaWdodD0iOTQiIHZpZXdCb3g9IjAgMCA1MiA5NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQ0IDAuODc1SDhDNC4wNjQ5NyAwLjg3NSAwLjg3NSA0LjA2NDk3IDAuODc1IDhWODZDMC44NzUgODkuOTM1IDQuMDY0OTcgOTMuMTI1IDggOTMuMTI1SDQ0QzQ3LjkzNSA5My4xMjUgNTEuMTI1IDg5LjkzNSA1MS4xMjUgODZWOEM1MS4xMjUgNC4wNjQ5NyA0Ny45MzUgMC44NzUgNDQgMC44NzVaIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNzUiLz4KPHBhdGggZD0iTTQ0IDMuNUg4QzUuNTE0NzIgMy41IDMuNSA1LjUxNDcyIDMuNSA4Vjg2QzMuNSA4OC40ODUzIDUuNTE0NzIgOTAuNSA4IDkwLjVINDRDNDYuNDg1MyA5MC41IDQ4LjUgODguNDg1MyA0OC41IDg2VjhDNDguNSA1LjUxNDcyIDQ2LjQ4NTMgMy41IDQ0IDMuNVoiIHN0cm9rZT0id2hpdGUiLz4KPHBhdGggZD0iTTIyLjQzNjMgMzJIOS4zOTY0OFY0NS40OTU3SDIyLjQzOTRMMjIuNDM2MyAzMlpNMTkuMTc0OCA0Mi4xMjFIMTIuNjU0OVYzNS4zNzQ3SDE5LjE3NDhWNDIuMTIxWk0yOC45NTYyIDM3SDQxLjk5OTFWNDAuMTIxSDI4Ljk1OTNMMjguOTU2MiAzN1pNMjguOTU5MyA1N0g0Mi4wMDIzTDQxLjk5OTEgNjAuMTY3NUwyOC45NTkzIDYwLjE3MDdWNTdaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjIgN0gzMCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTggN0gxOSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTAgNTguNUwxNSA2Mi41TDIyIDUyIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjMuNSIvPgo8L3N2Zz4K";